<template>
    <a-modal v-model="visible" :title="resources.name" width="1000px"
             :destroyOnClose="true" :centered="true"
             :footer="null" @cancel="onCancel">
        <a-breadcrumb v-if="breadcrumb.length > 1" style="margin-bottom: 14px;">
            <a-breadcrumb-item v-for="item in breadcrumb" href="javaScript: void(0);">
                <span @click="nextFolder(item)">{{ item.name }}</span>
            </a-breadcrumb-item>
        </a-breadcrumb>
        <a-table :columns="columns"
                 :scroll="{y: 350}"
                 rowKey="id"
                 :pagination="table.tablePagination"
                 :loading="table.tableLoading"
                 :dataSource="table.tableDataSource">
            <div slot="name" class="table-name" slot-scope="text" :title="text.fileName">
                <svg class="icon" aria-hidden="true">
                    <use v-if="text.fileType === 0" xlink:href="#icon-wenjianleixing-suolvetu-wenjianjia"></use>
                    <use v-if="text.fileType === 5" xlink:href="#icon-wenjianleixing-suolvetu-yasuowenjian"></use>
                    <use v-if="text.fileType === 2" xlink:href="#icon-wenjianleixing-suolvetu-tupianwenjian"></use>
                    <use v-if="text.fileType === 3" xlink:href="#icon-wenjianleixing-suolvetu-shengyinwenjian"></use>
                    <use v-if="text.fileType === 4" xlink:href="#icon-wenjianleixing-suolvetu-shipinwenjian"></use>
                    <use v-if="text.fileType === 1 && ['xls', 'xlsx'].includes(suffix(text.fileName))"
                         xlink:href="#icon-wenjianleixing-suolvetu-gongzuobiao"></use>
                    <use v-if="text.fileType === 1 && ['doc', 'docx'].includes(suffix(text.fileName))"
                         xlink:href="#icon-wenjianleixing-suolvetu-Word"></use>
                    <use v-if="text.fileType === 1 && ['ppt', 'pptx'].includes(suffix(text.fileName))"
                         xlink:href="#icon-wenjianleixing-suolvetu-huandengpian"></use>
                    <use v-if="text.fileType === 1 && suffix(text.fileName) === 'pdf'"
                         xlink:href="#icon-wenjianleixing-suolvetu-huandengpian"></use>
                </svg>
                <a-button @click="nextFolder(text)" v-if="!text.fileType" type="link">{{ text.name }}</a-button>
                <span v-else>{{ text.name + "." + suffix(text.fileName) }}</span>
            </div>
            <div slot="fileType" slot-scope="text">
                {{ fileType[text.fileType] }}
            </div>
            <div slot="childCourse" slot-scope="text">
                {{ resources.childConfigs.map(m => m.childCourseName).join(" ") }}
            </div>
            <div slot="action" slot-scope="text" class="action">
                <a v-if="text.fileType !== 5" @click="preview(text)">预览</a>
                <a v-if="resources.downloadAuthority && text.fileType !== 0" @click="download(text)">下载</a>
            </div>
        </a-table>
        <resources-file-view :key="fileView.key" v-model="fileView.visible" :resources="fileView.value"/>
    </a-modal>
</template>

<script>
import iconfont from "@/utils/aliIconfont/iconfont";
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import ResourcesFileView from "@/pages/content/courseSeting/components/ResourcesFileView"
import Api from "@/requests/apis";

export default {
    name: "ResourcesFolderView",
    components: {ResourcesFileView},
    props: {
        resources: {
            type: Object,
            required: true
        },
        visible: Boolean
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    data() {
        return {
            breadcrumb: [],
            fileType: ["文件夹", "文档", "图片", "音频", "视频", "压缩文件"],
            columns: [
                {title: "资源标题", scopedSlots: {customRender: "name"}, width: 250, ellipsis: true},
                {title: "资源文件", dataIndex: "fileName", width: 150, ellipsis: true},
                {title: "类型", scopedSlots: {customRender: "fileType"}, align: "center"},
                {title: "关联课时", scopedSlots: {customRender: "childCourse"}, align: "center"},
                {title: "操作", scopedSlots: {customRender: "action"}, align: "center"}
            ],
            table: tableRelevant.call(this),
            fileView: {
                visible: false,
                key: Date.now(),
                value: {}
            }
        }
    },
    mounted() {
        if (this.resources.fileResourceId) {
            this.table.search = this.resources;
            this.table.search.id = this.resources.fileResourceId;
            this.breadcrumb = [this.table.search];
            this.getPageList(1);
        }
    },
    methods: {
        getPageList(pageIndex) {
            const params = {
                pageIndex: pageIndex || this.table.tablePagination.current,
                pageSize: this.table.tablePagination.pageSize,
                id: this.table.search.id,
                isAll: false,
            };
            this.table.tableLoading = true;
            this.$http.FileResource.pagelist(params).then(res => {
                const {data, status, message} = res;
                    this.table.tableDataSource = data.items;
                    this.table.tablePagination.total = data.totalCount;
                    this.table.tablePagination.current = data.pageIndex;
                
            }).finally(() => {
              this.table.tableLoading = false;
            })
        },
        nextFolder(value) {
            if (this.table.search.id === value.id) {
                return
            }
            if (this.breadcrumb.length > 1 && this.breadcrumb.filter(f => f.id === this.table.search.id).length) {
                let bool = false;
                this.breadcrumb = this.breadcrumb.filter(f => {
                    if (!bool) {
                        bool = f.id === this.table.search.id;
                    }
                    return !bool;
                });
            } else {
                this.breadcrumb.push(value);
            }
            this.table.search = value;
            this.getPageList(1);
        },
        preview(value) {
            if (value.fileType === 0) {
                this.nextFolder(value);
                return
            }
            this.fileView.visible = true;
            this.fileView.value = value;
            this.fileView.key = Date.now();
        },
        suffix(str, point) {
            if (point) {
                return str.substring(str.lastIndexOf(".")).toLowerCase();
            }
            return str.substring(str.lastIndexOf(".") + 1).toLowerCase();
        },
        onCancel() {
            this.fileView.visible = false;
            this.fileView.value = {};
            this.$emit('change', false);
        },
        download(value) {
            let url = process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + value.id
            const a = document.createElement('a');
            a.href = url
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },
    }
}
</script>

<style lang="less" scoped>
.head-breadcrumb {
    display: flex;
    margin-bottom: 15px;

    span:not(:last-child) {
        cursor: pointer;

        &:hover {
            color: #666;
        }

    }
}

.icon {
    width: 14px;
    height: 14px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    margin-right: 5px;
    flex-shrink: 0;
}

.table-name {
    display: flex;
    align-items: center;

    .ant-btn, span {
        display: inline-block;
        padding: 0;
        max-width: 200px;
        height: 23px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

}
</style>
